import React, { useState } from 'react'
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from '../../framework/constant/constant';
import { useTranslation } from '../../locale/useTranslation';
import * as API from "../../framework/API/api"
import { utility } from '../../framework/utility/utilityProvider';
import { EditPageHeader } from '../../components/EditPageHeader';
import BossDialog from '../../components/BossDialog';
import ToastNotification from '../../components/ToastNotification';

const SponsorTypeEditForm = (props) => {

    const lang = useTranslation();

    const blankDataItem = {
        SID: props.item.SID ?? 0,
        Description: props.item.copy ? 'copy of ' + props.item.Description : props.item.Description ?? '',
        Rating: props.item.Rating ?? 0,
        Archive: props.item.Archive ?? false,
    }

    const [dataItem, setDataItem] = useState(blankDataItem);

    function validationCheck() {
        if (dataItem.Description == "" || dataItem.Description == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
            return false;
        }
        if (dataItem.Rating <= 0 || dataItem.Rating > 10 || dataItem.Rating == "" || dataItem.Rating == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_rating_error_message });
            return false;
        }
        return true;
    }

    const handleSubmit = async (e) => {

        if (validationCheck()) {
            const saveData = {
                SID: dataItem.SID ?? 0,
                Description: dataItem.Description,
                Rating: parseInt(dataItem.Rating),
                Archive: dataItem.Archive ?? false,
            }

            console.log(saveData);

            let res = await API.saveData(ENTITYNAME.SponsorType, saveData);
            if (res.success) {
                let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.SPONSOR_TYPE, data: res.data, message: res.message };
                API.SaveLogs(logData);  
                utility.deleteLocalStorageItem(ENTITYNAME.SponsorType);
                props.cancelEdit();
                props.refresh();
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
        }
    }

    const onChangeForm = (e) => {

        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }


    return (
        <>
            <BossDialog
                title={props.item.SID > 0 ? props.item.Description : "Sponsor Type"}
                onClose={props.cancelEdit}
                width={"500px"}
            >
                <div className="row">
                    <div className="col-12">
                        <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
                        <div className="row mt-2">
                            <div className="col">
                                <label>{lang.description_label} *</label>
                                <input
                                    name={"Description"}
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={onChangeForm}
                                    value={dataItem.Description}
                                />
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <label>{lang.rating_label} *</label>
                                <input
                                    name="Rating"
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={onChangeForm}
                                    value={dataItem.Rating}
                                    min={0}
                                />
                                <p className="list-unstyled blockquote-footer">{lang.note_for_sponsor_type_select_null_label}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col mt-3">
                                <input
                                    type={"checkbox"} name={"Archive"} style={{ marginTop: "10px" }}
                                    onChange={(e) => onChangeForm(e)}
                                    value={dataItem.Archive}
                                    checked={dataItem.Archive} />
                                <label className="ml-1">{lang.archive}</label>
                            </div>
                        </div>
                    </div>
                </div>

            </BossDialog>
        </>
    )
}

export default SponsorTypeEditForm
